import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AnonymousResolver, BuilderResolver, AccountGuard } from '@app/core/guards';
import { AppNotFoundComponent } from '@app/base/errors';
import { BuilderShellComponent } from '@app/shells/builder-shell';
import { AppShellComponent } from '@app/shells/app-shell';
import { ContractComponent } from '@app/modules/builder';

const routes: Routes = [
    { 
        path: '', 
        pathMatch: 'full', 
        redirectTo: 'sc/company',
        data: {
            allowAnonymous: true,
        }
     },  // Landing without defining any ldc, set the default one
    {
        path: ':ldc/builder', component: BuilderShellComponent, // receive the ldc and pass it to app shell to be parsed\validated
        children: [
            { path: '', loadChildren: () => import('src/app/modules/builder/base/builder.module').then(m => m.BuilderModule) },
            { path: 'contract/:user', pathMatch: 'prefix', redirectTo: 'contract'},
            { path: 'contract/:user/:id', pathMatch: 'prefix', redirectTo: 'contract'},
            { path: 'payment/:user/:id', pathMatch: 'prefix', redirectTo: 'payment'}
        ],
        canActivate: [AccountGuard],
        resolve: { accountInfo: BuilderResolver }
    },

    {
        path: ':ldc', component: AppShellComponent, // receive the ldc and pass it to app shell to be parsed\validated
        children: [
            { path: 'applicant', loadChildren: () => import('src/app/modules/applicant/base/applicant.module').then(m => m.ApplicantModule) },
            { path: '', loadChildren: () => import('src/app/modules/landing/base/landing.module').then(m => m.LandingModule) },
            { path: '**', component: AppNotFoundComponent }
        ],
        resolve: { accountInfo: AnonymousResolver },
        data: {
            allowAnonymous: true,
        }
    }
];

@NgModule({
    // All lazy loaded modules will be downloaded when app finish bootstrapping.
    // To load modules on demand, remove PreloadAllModules or implement custom preloadingStrategy`
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule],
    providers: [
        AnonymousResolver,
        BuilderResolver,
        AccountGuard
    ]
})
export class AppRoutingModule {}
